export enum EEditBetManagerDispatchActions {
  TOGGLE_EDIT_BET = 'TOGGLE_EDIT_BET',
  CLEAR_EDIT_BET = 'CLEAR_EDIT_BET'
}
